var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFollowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4974 2.5C17.7184 2.5 17.9304 2.5878 18.0867 2.74408C18.2429 2.90036 18.3307 3.11232 18.3307 3.33333V15C18.3307 15.221 18.2429 15.433 18.0867 15.5893C17.9304 15.7455 17.7184 15.8333 17.4974 15.8333H5.37656L1.66406 18.75V3.33333C1.66406 3.11232 1.75186 2.90036 1.90814 2.74408C2.06442 2.5878 2.27638 2.5 2.4974 2.5H17.4974ZM16.6641 4.16667H3.33073V15.3208L4.7999 14.1667H16.6641V4.16667ZM14.1641 5.83333V12.5H12.4974V5.83333H14.1641ZM9.16406 6.66667V8.3325L10.8307 8.33333V10L9.16406 9.99917V11.6667H7.4974V9.99917L5.83073 10V8.33333L7.4974 8.3325V6.66667H9.16406Z",
    fill: "#2783EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFollowUp);
export default __webpack_public_path__ + "static/media/icon-follow-up.1ffbc4f62948bbd42ace8a2e7cbddc35.svg";
export { ForwardRef as ReactComponent };